import { isEmpty } from 'lodash';

let config = {};

if (isEmpty(window._env_)) {
  config = {
    VERSION: process.env.REACT_APP_VERSION,
    API_URL: process.env.REACT_APP_API_URL || '',
    ECHO_HOST_AUTH: process.env.REACT_APP_ECHO_HOST_AUTH,
    ECHO_HOST: process.env.REACT_APP_ECHO_HOST,
    ECHO_PORT: process.env.REACT_APP_ECHO_PORT,
    PUSHER_KEY: process.env.REACT_APP_PUSHER_KEY,
    PUSHER_CLUSTER: process.env.REACT_APP_PUSHER_CLUSTER,
    SKYLINK_APP_KEY: process.env.REACT_APP_SKYLINK_APP_KEY,
    FACE_COMPARISON: process.env.REACT_APP_FACE_COMPARISON,
    AUDIO_TRANSCRIPTION: process.env.REACT_APP_AUDIO_TRANSCRIPTION,
    DOCUMENT_RECOGNITION: process.env.REACT_APP_DOCUMENT_RECOGNITION,
    LOGOUT_URL: process.env.REACT_APP_LOGOUT_URL,
    REQUIRED_WORKON: process.env.REACT_APP_REQUIRED_WORKON,
    FAVICON: process.env.REACT_APP_FAVICON,
    TITLE: process.env.REACT_APP_TITLE,
    DASHBOARD_TITLE: process.env.REACT_APP_DASHBOARD_TITLE,

    LOGIN_LOGO_IMAGE: process.env.REACT_APP_LOGIN_LOGO_IMAGE,
    LOGIN_RIGHT_IMAGE: process.env.REACT_APP_LOGIN_RIGHT_IMAGE,
    LOGIN_RIGHT_IMAGE_BACKGROUND_COLOR:
      process.env.REACT_APP_LOGIN_RIGHT_IMAGE_BACKGROUND_COLOR,
    LOGIN_RIGHT_IMAGE_TEXT_FIRST:
      process.env.REACT_APP_LOGIN_RIGHT_IMAGE_TEXT_FIRST,
    LOGIN_RIGHT_IMAGE_TEXT_SECOND:
      process.env.REACT_APP_LOGIN_RIGHT_IMAGE_TEXT_SECOND,
    LOGIN_RIGHT_IMAGE_TEXT_THIRD:
      process.env.REACT_APP_LOGIN_RIGHT_IMAGE_TEXT_THIRD,
    LOGIN_RIGHT_IMAGE_TEXT_FIRST_COLOR:
      process.env.REACT_APP_LOGIN_RIGHT_IMAGE_TEXT_FIRST_COLOR,
    LOGIN_RIGHT_IMAGE_TEXT_SECOND_COLOR:
      process.env.REACT_APP_LOGIN_RIGHT_IMAGE_TEXT_SECOND_COLOR,
    LOGIN_RIGHT_IMAGE_TEXT_THIRD_COLOR:
      process.env.REACT_APP_LOGIN_RIGHT_IMAGE_TEXT_THIRD_COLOR,
    LOGIN_RIGHT_IMAGE_TEXT_COLOR:
      process.env.REACT_APP_LOGIN_RIGHT_IMAGE_TEXT_COLOR,
    LOGIN_BUTTON_LOGIN_BACKGROUND_COLOR:
      process.env.REACT_APP_LOGIN_BUTTON_LOGIN_BACKGROUND_COLOR,
    LOGIN_BUTTON_LOGIN_COLOR: process.env.REACT_APP_LOGIN_BUTTON_LOGIN_COLOR,
    WINDOWS_LOGIN_BUTTON_BACKGROUND_COLOR:
      process.env.REACT_APP_WINDOWS_LOGIN_BUTTON_BACKGROUND_COLOR,
    WINDOWS_LOGIN_BUTTON_COLOR:
      process.env.REACT_APP_WINDOWS_LOGIN_BUTTON_COLOR,
    LOGIN_BUTTON_FORGOT_PASSWORD_COLOR:
      process.env.REACT_APP_LOGIN_BUTTON_FORGOT_PASSWORD_COLOR,
    LOGIN_PRIMARY_COLOR_MAIN: process.env.REACT_APP_LOGIN_PRIMARY_COLOR_MAIN,
    LOGIN_PRIMARY_COLOR_MAIN_DARK:
      process.env.REACT_APP_LOGIN_PRIMARY_COLOR_MAIN_DARK,
    LOGIN_PRIMARY_COLOR_MAIN_LIGHT:
      process.env.REACT_APP_LOGIN_PRIMARY_COLOR_MAIN_LIGHT,
    LOGIN_HEADER_IMAGE: process.env.REACT_APP_LOGIN_HEADER_IMAGE,
    BETA: process.env.REACT_APP_BETA,
    IDENTITY_VERIFICATION_REPORT:
      process.env.REACT_APP_IDENTITY_VERIFICATION_REPORT,
  };
} else {
  config = {
    VERSION: window._env_.REACT_APP_VERSION,
    API_URL: window._env_.REACT_APP_API_URL || '',
    ECHO_HOST_AUTH: window._env_.REACT_APP_ECHO_HOST_AUTH,
    ECHO_HOST: window._env_.REACT_APP_ECHO_HOST,
    ECHO_PORT: window._env_.REACT_APP_ECHO_PORT,
    PUSHER_KEY: window._env_.REACT_APP_PUSHER_KEY,
    PUSHER_CLUSTER: window._env_.REACT_APP_PUSHER_CLUSTER,
    SKYLINK_APP_KEY: window._env_.REACT_APP_SKYLINK_APP_KEY,
    FACE_COMPARISON: window._env_.REACT_APP_FACE_COMPARISON,
    AUDIO_TRANSCRIPTION: window._env_.REACT_APP_AUDIO_TRANSCRIPTION,
    DOCUMENT_RECOGNITION: window._env_.REACT_APP_DOCUMENT_RECOGNITION,
    LOGOUT_URL: window._env_.REACT_APP_LOGOUT_URL,
    REQUIRED_WORKON: window._env_.REACT_APP_REQUIRED_WORKON,
    FAVICON: window._env_.REACT_APP_FAVICON,
    DASHBOARD_TITLE: window._env_.REACT_APP_DASHBOARD_TITLE,
    TITLE: window._env_.REACT_APP_TITLE,
    LOGIN_LOGO_IMAGE: window._env_.REACT_APP_LOGIN_LOGO_IMAGE,
    LOGIN_RIGHT_IMAGE: window._env_.REACT_APP_LOGIN_RIGHT_IMAGE,
    LOGIN_RIGHT_IMAGE_BACKGROUND_COLOR:
      window._env_.REACT_APP_LOGIN_RIGHT_IMAGE_BACKGROUND_COLOR,
    LOGIN_RIGHT_IMAGE_TEXT_FIRST:
      window._env_.REACT_APP_LOGIN_RIGHT_IMAGE_TEXT_FIRST,
    LOGIN_RIGHT_IMAGE_TEXT_SECOND:
      window._env_.REACT_APP_LOGIN_RIGHT_IMAGE_TEXT_SECOND,
    LOGIN_RIGHT_IMAGE_TEXT_THIRD:
      window._env_.REACT_APP_LOGIN_RIGHT_IMAGE_TEXT_THIRD,
    LOGIN_RIGHT_IMAGE_TEXT_FIRST_COLOR:
      window._env_.REACT_APP_LOGIN_RIGHT_IMAGE_TEXT_FIRST_COLOR,
    LOGIN_RIGHT_IMAGE_TEXT_SECOND_COLOR:
      window._env_.REACT_APP_LOGIN_RIGHT_IMAGE_TEXT_SECOND_COLOR,
    LOGIN_RIGHT_IMAGE_TEXT_THIRD_COLOR:
      window._env_.REACT_APP_LOGIN_RIGHT_IMAGE_TEXT_THIRD_COLOR,
    LOGIN_RIGHT_IMAGE_TEXT_COLOR:
      window._env_.REACT_APP_LOGIN_RIGHT_IMAGE_TEXT_COLOR,
    LOGIN_BUTTON_LOGIN_BACKGROUND_COLOR:
      window._env_.REACT_APP_LOGIN_BUTTON_LOGIN_BACKGROUND_COLOR,
    LOGIN_BUTTON_LOGIN_COLOR: window._env_.REACT_APP_LOGIN_BUTTON_LOGIN_COLOR,
    WINDOWS_LOGIN_BUTTON_BACKGROUND_COLOR:
      window._env_.REACT_APP_WINDOWS_LOGIN_BUTTON_BACKGROUND_COLOR,
    WINDOWS_LOGIN_BUTTON_COLOR:
      window._env_.REACT_APP_WINDOWS_LOGIN_BUTTON_COLOR,
    LOGIN_BUTTON_FORGOT_PASSWORD_COLOR:
      window._env_.REACT_APP_LOGIN_BUTTON_FORGOT_PASSWORD_COLOR,
    LOGIN_PRIMARY_COLOR_MAIN: window._env_.REACT_APP_LOGIN_PRIMARY_COLOR_MAIN,
    LOGIN_PRIMARY_COLOR_MAIN_DARK:
      window._env_.REACT_APP_LOGIN_PRIMARY_COLOR_MAIN_DARK,
    LOGIN_PRIMARY_COLOR_MAIN_LIGHT:
      window._env_.REACT_APP_LOGIN_PRIMARY_COLOR_MAIN_LIGHT,
    LOGIN_HEADER_IMAGE: window._env_.REACT_APP_LOGIN_HEADER_IMAGE,
    BETA: window._env_.REACT_APP_BETA,
    IDENTITY_VERIFICATION_REPORT:
      window._env_.REACT_APP_IDENTITY_VERIFICATION_REPORT,
  };
}

export default config;
